import { Box } from "@mui/material";
import HeroSection from "./components/HeroSection/HeroSection";
import AboutUsSection from "./components/AboutUs/AboutUsSection";
import ChooseUsSection from "./components/ChooseUs/ChooseUsSection";
import OurBenefits from "./components/OurBenefits/OurBenefits";
import FaqSection from "./components/FAQSection/FaqSection";
import { useEffect } from "react";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ overflowX: "scroll" }}>
      <HeroSection />
      <AboutUsSection />
      <ChooseUsSection />
      <OurBenefits />
      <FaqSection />
    </Box>
  );
};
export default HomePage;
